export default {
  labels: {
    google_place: 'Google place',
    live: 'Live',
    setting_up: 'Setting up',
  },
  buttons: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    continue_setup: 'Continue Setup',
  },
  delete_confirmation: 'Are you sure?',
};
